/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParentGroup
 */
export interface ParentGroup {
    /**
     * 
     * @type {number}
     * @memberof ParentGroup
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ParentGroup
     */
    name?: string;
}

/**
 * Check if a given object implements the ParentGroup interface.
 */
export function instanceOfParentGroup(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ParentGroupFromJSON(json: any): ParentGroup {
    return ParentGroupFromJSONTyped(json, false);
}

export function ParentGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParentGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function ParentGroupToJSON(value?: ParentGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

